import { Route, Redirect } from 'react-router-dom';
import { useUser } from 'services/user';
import { rbac } from '@lib/common';
import { useSnackbar } from 'notistack';

export const ProtectedRoute = (props: React.ComponentProps<typeof Route>) => {
  const { isLoggedIn } = useUser();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  if(!isLoggedIn){
    return <Redirect to="/login" />
  }
  if(props.location.pathname !='/landing-page' && rbac(props.location.pathname,"", "pages")){
    // show snackbar
    enqueueSnackbar(`This role does not have access to this page`, { variant: 'error' });
    return <Redirect to="/landing-page" />
  }

  return <Route {...props} />;

  // return isLoggedIn ? <Route {...props} /> : <Redirect to="/login" />;
};
